module.exports = __webpack_public_path__ + "static/media/tutorial-gain-skill.62b33235.png";